/**
 * 分享
 */

import { Modal, Form, Input, Checkbox, Radio, Row, Col, message } from 'antd';
import React, { useState } from 'react';
import { VerifyShareFormData, AccountType, PermissionType } from '../../type';

interface IEditGroupProps {
  visible: boolean;
  onCancel: () => void;
  handleOk: (data: { accountType: string; accounts: string[]; permissions: string[] }) => void;
  title: string;
}

const ACCOUNT_TYPE_LABEL: Record<string, string> = {
  internal: '内部用户',
  merchant: '商家用户',
};

const PERMISSION_LABEL: Record<string, string> = {
  edit: '编辑',
  copy: '复制',
  relevance: '关联',
};

interface ShareFormData {
  accountType: AccountType;
  accounts: string;
  permissions: PermissionType[];
}

const ShareGroup = (props: IEditGroupProps) => {
  const { visible, onCancel, handleOk, title } = props;
  const [shareFormRef] = Form.useForm<VerifyShareFormData>();
  const [accountType, setAccountType] = useState('internal');

  const splitAccounts = (str: string) => {
    return str
      .split(/[,，\n]/u)
      .map((s) => s.trim())
      .filter((s) => s);
  };

  const handleSave = async () => {
    try {
      const res = await shareFormRef.validateFields();
      if (!res.accounts) {
        message.info('请输入erp账号');
        return;
      }
      const data = {
        accountType: res.accountType,
        accounts: splitAccounts(res.accounts),
        permissions: res.permissions,
      };
      handleOk(data);
    } catch (e) {}
  };

  const updateStateFromForm = (values: ShareFormData) => {
    setAccountType(values.accountType);
  };

  return (
    <Modal
      title={`分享${title ? `"${title}"` : ''}给`}
      visible={visible}
      width="640px"
      onOk={handleSave}
      onCancel={onCancel}
      destroyOnClose
    >
      <Form<VerifyShareFormData>
        form={shareFormRef}
        labelCol={{ span: 4 }}
        wrapperCol={{ span: 18 }}
        onValuesChange={(_, values: ShareFormData) => {
          updateStateFromForm(values);
        }}
      >
        <Form.Item name="accountType" label="操作类型" initialValue={'internal'}>
          <Radio.Group>
            {['internal', 'merchant'].map((at: string) => (
              <Radio key={at} value={at}>
                {ACCOUNT_TYPE_LABEL[at]}
              </Radio>
            ))}
          </Radio.Group>
        </Form.Item>
        <Form.Item name="accounts" label="账号">
          <Input.TextArea
            autoSize={{ minRows: 6, maxRows: 12 }}
            placeholder={`请输出${ACCOUNT_TYPE_LABEL[accountType]}账号，以逗号分隔。`}
          />
        </Form.Item>
        <Form.Item name="permissions" label="允许对方" initialValue={['edit', 'copy', 'relevance']}>
          <Checkbox.Group>
            <Row>
              {['edit', 'copy', 'relevance'].map((perm) => (
                <Col key={perm} span={8}>
                  <Checkbox key={perm} value={perm} style={{ lineHeight: '32px' }}>
                    {PERMISSION_LABEL[perm]}
                  </Checkbox>
                </Col>
              ))}
            </Row>
          </Checkbox.Group>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default ShareGroup;
